import React, { useEffect, useState } from 'react';
import Button from '../../components/Button/Button';
import { Link } from 'react-router-dom';
import { getFormCheck, getQR, getStudentById, updateStudentById } from '../../services/studentApi';
import { AiOutlineLoading } from "react-icons/ai";
import { convertToUTCDateInputFormat } from '../../utils/utility';
import useFormValidation from '../../hooks/useFormValidation';
import { infoFormValidationSchema } from '../../utils/formValidation';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { errorToast } from '../../utils/errorHandling';
import CustomModal from '../../components/CustomModal';

const base_url = process.env.REACT_APP_BASE_URL

const ViewPersonalInfo = () => {
    const { t } = useTranslation();
    const [originalData, setOriginalData] = useState({});
    const [formData, setFormData] = useState("");
    const [formcheck, setFormcheck] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const { errors, validateField, validateAllFields } = useFormValidation(infoFormValidationSchema(t));
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [qr, setQr] = useState();
    const user_id = JSON.parse(localStorage.getItem('user_id'));
    const participant_id = JSON.parse(localStorage.getItem('participant_id'));
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };
    const fetchStudent = async () => {
        try {
            const res = await getStudentById(user_id);
            if (res) {
                setFormData(res);
                setOriginalData(res);
            }
        } catch (error) {
            throw (error);
        }
    };
    const fetchFormCheck = async () => {
        try {
            const formCheckData = await getFormCheck(participant_id);
            if (formCheckData) {
                setFormcheck(formCheckData);
            }
        } catch (error) {
            throw (error);
        }
    };
    const fetchQr = async () => {
        try {
            const response = await getQR(user_id);
            const url = URL.createObjectURL(new Blob([response], { type: "image/png" }));
            setQr(url);
        } catch (error) {
            throw (error);
        }
    };

    useEffect(() => {
        const personalInfoApiSeries = async () => {
            try {
                setIsLoading(true);
                await fetchFormCheck();
                await fetchStudent();
                await fetchQr();
            } catch (error) {
                errorToast(error, t('general.ActionFailed'), t);
            } finally {
                setIsLoading(false);
            }
        }
        personalInfoApiSeries()
    }, []);

    const handleInputChange = (e) => {
        const { id, value, name } = e.target;
        if (name === 'gender') {
            const genderSelected = id === "male" ? "Male" : "Female";
            setFormData((prevState) => ({
                ...prevState,
                [name]: genderSelected,
            }));
        } else if (name === 'identity') {
            if (id === "lay") {
                setFormData((prevState) => ({
                    ...prevState,
                    sangha_cname: "",
                    sangha_ename: "",
                    [name]: id,
                }));
                validateField(name, id);
            } else {
                setFormData((prevState) => ({
                    ...prevState,
                    [name]: id,
                }));
                validateField(name, id);
            }
        } else if (name === "is_medicine_allergic" || name === "is_disease" || name === "is_food_allergic"
            || name === "is_vege" || name === "is_nofoodaftermidday"
        ) {
            if (name === "is_medicine_allergic" && id === "0") {
                setFormData((prevState) => ({
                    ...prevState,
                    medicine_allergic_details: "",
                    [name]: id,
                }));
            } else if (name === "is_disease" && id === "0") {
                setFormData((prevState) => ({
                    ...prevState,
                    disease_details: "",
                    [name]: id,
                }));
            } else if (name === "is_food_allergic" && id === "0") {
                setFormData((prevState) => ({
                    ...prevState,
                    food_allergic_details: "",
                    [name]: id,
                }));
            } else {
                setFormData((prevState) => ({
                    ...prevState,
                    [name]: id,
                }));
            }
            validateField(name, id);

        } else {
            setFormData((prevState) => ({
                ...prevState,
                [id]: value,
            }));
            validateField(id, value);
        }
    };

    const handleCancel = () => {
        setFormData(originalData);
        setIsEditing(false);
    };

    const handleSubmit = () => {
        const updatePersonalInfo = async () => {
            try {
                const res = await updateStudentById(user_id, formData);
                if (res.data.success) {
                    setOriginalData(res.data.data);
                    setFormData(res.data.data);
                    toggleModal();
                    setIsEditing(false);
                    toast.success(t("personal_info.UpdateSuccess"));
                }
            } catch (error) {
                errorToast(error, t("personal_info.UpdateFailed"), t);
            } finally {
                setIsSubmitting(false);
            }
        }
        setIsSubmitting(true);

        let formValidationSchema = ['cname', 'ename', 'gender', 'birthdate',
            'identity', 'mobile', 'email', 'whatsapp', 'wechat_id', 'wechat_name', 'line_id',
            'is_medicine_allergic', 'is_disease', 'is_food_allergic', 'emergency_contact_name', 'emergency_contact_no',
            'emergency_contact_alternative', 'is_vege', 'is_nofoodaftermidday'];

        formData.is_disease === "1" && formValidationSchema.push("disease_details")
        formData.is_food_allergic === "1" && formValidationSchema.push('food_allergic_details')
        formData.is_medicine_allergic === "1" && formValidationSchema.push("medicine_allergic_details")
        if (formData.identity === "sangha") {
            formValidationSchema.push("sangha_cname");
            formValidationSchema.push("sangha_ename");
        }
        const dateObj = new Date(formData.birthdate);
        formData.birthdate = dateObj.toISOString().split("T")[0];  // e.g. "2000-07-11"

        if (validateAllFields(formData, formValidationSchema)) {
            updatePersonalInfo();
        } else {
            toast.error(t("personal_info.ValidateFailedfield"));
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <CustomModal
                hideModal={toggleModal}
                open={isModalOpen}
                performAction={() => handleSubmit()}
                title={t("personal_info.confirmEnglishName")}
                confirmLoading={isSubmitting}
                children={
                    <p>
                        {t("personal_info.enameWarn")}
                        <div className="form-item mt-3">
                            <input type="text" disabled={!isEditing} className="form-control" id="ename" placeholder="" value={formData.ename || ""} onChange={handleInputChange} required />
                        </div>
                        {errors.ename && <span className="error">{errors.ename}</span>}
                    </p>
                }
            />
            {formData === "" ?
                <div className='info-container'>
                    <h3>{t("personal_info.title")}</h3>
                    <p>{t("personal_info.description")}</p>
                    {isLoading ?
                        <>
                            <AiOutlineLoading className='spin' />
                            <p>{t("personal_info.msg_loading")}</p>
                        </>
                        :
                        <>
                            <p style={{ "color": "#ff0000" }}>{t("personal_info.msg_error")}<br /> {t("personal_info.msg_admin")}</p>
                            <div className='action-buttons'>
                                <Link to="https://www.shineling.org:3004" target="_blank" rel="noopener noreferrer">
                                    <Button
                                        buttonStyle='btn--primary'
                                        buttonSize='btn--small'
                                    >{t("personal_info.contact_admin")}</Button>
                                </Link>

                            </div>
                        </>
                    }

                </div>
                :
                <>
                    <div className='info-container'>
                        <div className='d-flex justify-content-center flex-wrap'>
                            <div>
                                <h3>{t("personal_info.title")}</h3>
                                <p>{t("personal_info.description")}</p>
                                <div className='action-buttons'>
                                    <Link to={`${base_url}/passport-info`}>
                                        <Button
                                            buttonStyle='btn--primary'
                                            buttonSize='btn--small'
                                        >{t("personal_info.passport_info")}</Button>
                                    </Link>
                                    <Link to={`${base_url}/view_experience`}>
                                        <Button
                                            buttonStyle='btn--primary'
                                            buttonSize='btn--small'
                                        >{t("personal_info.retreat_experience")}</Button>
                                    </Link>
                                </div>

                            </div>
                            <div className='d-flex justify-content-center'>
                                {qr && <img src={qr} alt="QR Code" width={"250px"} />}
                            </div>
                        </div>
                    </div>
                    <div className='form-wrapper mt-2'>
                        <form>
                            {!isEditing ?
                                <div className='mt-3'>
                                    {formcheck.is_personal_info_filled === "0" &&
                                        <p className='error text-center'>{t("personal_info.CompleteForm")}</p>
                                    }
                                    <div className='d-flex justify-content-center'>
                                        <Button
                                            buttonStyle='btn--primary'
                                            buttonSize='btn--small'
                                            onClick={() => setIsEditing(true)}
                                        >{formcheck.is_personal_info_filled === "0" ? t("personal_info.BTNcomplete") : t("personal_info.edit_info")}</Button>
                                    </div>
                                </div>
                                :
                                <div className='mt-3'>
                                    <div className='d-flex justify-content-center'>
                                        <Button buttonStyle='btn--primary' onClick={handleCancel} type="button">{t("personal_info.cancel")}</Button>
                                    </div>
                                    <p className='error mt-2 mb-0 text-center'>{t("personal_info.StartComplete")}</p>
                                </div>
                            }
                            <div className="form-item">
                                <label className="form-label">{t("personal_info.student_id")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                <input type="text" disabled className="form-control" id="student_id" placeholder="" value={formData.student_no || ""} onChange={handleInputChange} required />
                            </div>
                            <div className="form-item">
                                <label className="form-label">{t("personal_info.cname")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                <input type="text" disabled={!isEditing} className="form-control" id="cname" placeholder="" value={formData.cname || ""} onChange={handleInputChange} required />
                            </div>
                            {errors.cname && <span className="error">{errors.cname}</span>}
                            <div className="form-item">
                                <label className="form-label">{t("personal_info.ename")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                <input type="text" disabled={!isEditing} className="form-control" id="ename" placeholder="" value={formData.ename || ""} onChange={handleInputChange} required />
                            </div>
                            {errors.ename && <span className="error">{errors.ename}</span>}
                            <div className="form-item">
                                <label>{t("personal_info.identity")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                <div className='radio'>
                                    <input className="form-check-input" disabled={!isEditing} type="radio" name="identity" id="lay" checked={formData.identity === "lay"} onChange={handleInputChange} required />
                                    <p className='radioLabel mb-0'>{t("personal_info.lay")}</p>
                                </div>
                                <div className='radio'>
                                    <input className="form-check-input" disabled={!isEditing} type="radio" name="identity" id="sangha" checked={formData.identity === "sangha"} onChange={handleInputChange} required />
                                    <p className='radioLabel mb-0'>{t("personal_info.sangha")}</p>
                                </div>
                            </div>
                            {formData.identity === "sangha" &&
                                <>
                                    <div className="form-item">
                                        <label>{t("personal_info.sangha_cname")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                        <input type="text" disabled={!isEditing} className="form-control" id="sangha_cname" placeholder="" value={formData.sangha_cname || ""} onChange={handleInputChange} required />
                                    </div>
                                    {errors.sangha_cname && <span className="error">{errors.sangha_cname}</span>}
                                    <div className="form-item">
                                        <label className="form-label">{t("personal_info.sangha_ename")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                        <input type="text" disabled={!isEditing} className="form-control" id="sangha_ename" placeholder="" value={formData.sangha_ename || ""} onChange={handleInputChange} required />
                                    </div>
                                    {errors.sangha_ename && <span className="error">{errors.sangha_ename}</span>}
                                </>
                            }
                            <div className="form-item">
                                <label>{t("personal_info.gender")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                <div className='radio'>
                                    <input disabled={!isEditing} className="form-check-input" type="radio" name="gender" id="male" checked={formData.gender === "Male"} onChange={handleInputChange} required />
                                    <p className='radioLabel mb-0'>{t("personal_info.male")}</p>
                                </div>
                                <div className='radio'>
                                    <input disabled={!isEditing} className="form-check-input" type="radio" name="gender" id="female" checked={formData.gender === "Female"} onChange={handleInputChange} required />
                                    <p className='radioLabel mb-0'>{t("personal_info.female")}</p>
                                </div>
                            </div>
                            <div className="form-item">
                                <label className="form-label">{t("personal_info.birthdate")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                <input type="date" disabled={!isEditing} className="form-control" id="birthdate" placeholder="" value={formData.birthdate ? convertToUTCDateInputFormat(formData.birthdate) : ""} onChange={handleInputChange} required />
                            </div>
                            {errors.birthdate && <span className="error">{errors.birthdate}</span>}
                            <div className="form-item">
                                <label className="form-label">{t("personal_info.mobile")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                <input type="text" disabled={!isEditing} className="form-control" id="mobile" placeholder="e.g. 60123456789" value={formData.mobile || ""} onChange={handleInputChange} required />
                            </div>
                            {errors.mobile && <span className="error">{errors.mobile}</span>}
                            <div className="form-info">
                                <p className='m-0'>{t("personal_info.mobile_msg")}<br />{t("personal_info.mobile_country")}</p>
                            </div>
                            <div className="form-item">
                                <label className="form-label">{t("personal_info.whatsapp")}</label>
                                <input type="text" disabled={!isEditing} className="form-control" id="whatsapp" placeholder="" value={formData.whatsapp || ""} onChange={handleInputChange} required />
                            </div>
                            {errors.whatsapp && <span className="error">{errors.whatsapp}</span>}
                            <div className="form-info">
                                <p className='p-0 m-0'>{t("personal_info.whatsapp_msg")}<br />{t("personal_info.whatsapp_country")}</p>
                            </div>
                            <div className="form-item">
                                <label className="form-label">{t("personal_info.email")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                <input type="text" disabled={!isEditing} className="form-control" id="email" placeholder="" value={formData.email || ""} onChange={handleInputChange} required />
                            </div>
                            {errors.email && <span className="error">{errors.email}</span>}
                            <div className="form-item">
                                <label className="form-label">{t("personal_info.wechatid")}</label>
                                <input type="text" disabled={!isEditing} className="form-control" id="wechat_id" placeholder="" value={formData.wechat_id || ""} onChange={handleInputChange} />
                            </div>
                            <div className="form-item">
                                <label className="form-label">{t("personal_info.wechat")}</label>
                                <input type="text" disabled={!isEditing} className="form-control" id="wechat_name" placeholder="" value={formData.wechat_name || ""} onChange={handleInputChange} />
                            </div>
                            <div className="form-item">
                                <label className="form-label">{t("personal_info.line")}</label>
                                <input type="text" disabled={!isEditing} className="form-control" id="line_id" placeholder="" value={formData.line_id || ""} onChange={handleInputChange} />
                            </div>
                            <div className="form-item">
                                <label className="form-label">{t("personal_info.emergency_name")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                <input type="text" disabled={!isEditing} className="form-control" id="emergency_contact_name" value={formData.emergency_contact_name || ""} onChange={handleInputChange} required />
                            </div>
                            {errors.emergency_contact_name && <span className="error">{errors.emergency_contact_name}</span>}
                            <div className="form-item">
                                <label className="form-label">{t("personal_info.emergency_contact")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                <input type="text" disabled={!isEditing} className="form-control" id="emergency_contact_no" value={formData.emergency_contact_no || ""} onChange={handleInputChange} required />
                            </div>
                            <div className="form-info">
                                <p className='m-0'>{t("personal_info.mobile_msg")}<br />{t("personal_info.mobile_country")}</p>
                            </div>
                            {errors.emergency_contact_no && <span className="error">{errors.emergency_contact_no}</span>}
                            <div className="form-item">
                                <label className="form-label">{t("personal_info.emergency_alternative")}</label>
                                <input type="text" placeholder="WeChat (0123456789)" disabled={!isEditing} className="form-control" id="emergency_contact_alternative" value={formData.emergency_contact_alternative || ""} onChange={handleInputChange} />
                            </div>
                            <div className='section-title mb-2 mt-5'>
                                <h4 className='mb-0'>{t("personal_info.RetreatMeal")}</h4>
                            </div>
                            <h4>{t("personal_info.MealOP")}</h4>
                            <div className='section-description pt-2'>
                                <p>{t("personal_info.mealInstruc")}</p>
                                <p>
                                    {t("personal_info.mealInstruc1")}
                                    <span style={{ "color": "#ff0000" }}><strong> {t("personal_info.mealInstruc2")}</strong></span>
                                </p>
                            </div>
                            <div className="form-item">
                                <label>{t("personal_info.Ques1")}
                                    <span style={{ "color": "#ff0000" }}>*</span></label>
                                <div className='radio'>
                                    <input className="form-check-input" disabled={!isEditing} type="radio" name="is_vege" id="1" checked={formData.is_vege === "1"} onChange={handleInputChange} required />
                                    <p className='radioLabel mb-0'>{t("personal_info.Choice1")}</p>
                                </div>
                                <div className='radio'>
                                    <input className="form-check-input" disabled={!isEditing} type="radio" name="is_vege" id="0" checked={formData.is_vege === "0"} onChange={handleInputChange} required />
                                    <p className='radioLabel mb-0'>{t("personal_info.Choice2")}</p>
                                </div>
                            </div>
                            {errors.is_vege && <span className="error">{errors.is_vege}</span>}
                            <div className="form-item">
                                <label>{t("personal_info.Ques2")}
                                    <span style={{ "color": "#ff0000" }}>*</span></label>
                                <div className='radio'>
                                    <input className="form-check-input" disabled={!isEditing} type="radio" name="is_nofoodaftermidday" id="1" checked={formData.is_nofoodaftermidday === "1"} onChange={handleInputChange} required />
                                    <p className='radioLabel mb-0'>{t("general.yes")}</p>
                                </div>
                                <div className='radio'>
                                    <input className="form-check-input" disabled={!isEditing} type="radio" name="is_nofoodaftermidday" id="0" checked={formData.is_nofoodaftermidday === "0"} onChange={handleInputChange} required />
                                    <p className='radioLabel mb-0'>{t("general.no")}</p>
                                </div>
                            </div>
                            {errors.is_nofoodaftermidday && <span className="error">{errors.is_nofoodaftermidday}</span>}
                            <div className='section-title mt-5'>
                                <h4 className='mb-0'>{t("personal_info.HealthDeclare")}</h4>
                            </div>
                            <div className='section-description pt-2'>
                                <p>{t("personal_info.Instruction")}</p>
                            </div>
                            <div className="form-item">
                                <label>{t("personal_info.Question1")}
                                    <span style={{ "color": "#ff0000" }}>*</span></label>
                                <div className='radio'>
                                    <input className="form-check-input" disabled={!isEditing} type="radio" name="is_disease" id="1" checked={formData.is_disease === "1"} onChange={handleInputChange} required />
                                    <p className='radioLabel mb-0'>{t("general.yes")}</p>
                                </div>
                                <div className='radio'>
                                    <input className="form-check-input" disabled={!isEditing} type="radio" name="is_disease" id="0" checked={formData.is_disease === "0"} onChange={handleInputChange} required />
                                    <p className='radioLabel mb-0'>{t("general.no")}</p>
                                </div>
                            </div>
                            {errors.is_disease && <span className="error">{errors.is_disease}</span>}
                            {formData?.is_disease && formData?.is_disease === "1" &&
                                <>
                                    <div className="form-item">
                                        <label for="disease_details" className="form-label">{t("personal_info.Question2")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                        <textarea type="text" disabled={!isEditing} className="form-control" id="disease_details" value={formData.disease_details || ""} onChange={handleInputChange} />
                                    </div>
                                    {errors.disease_details && <span className="error">{errors.disease_details}</span>}
                                </>
                            }
                            <div className="form-item">
                                <label>{t("personal_info.Question3")}
                                    <span style={{ "color": "#ff0000" }}>*</span></label>
                                <div className='radio'>
                                    <input className="form-check-input" disabled={!isEditing} type="radio" name="is_food_allergic" id="1" checked={formData.is_food_allergic === "1"} onChange={handleInputChange} required />
                                    <p className='radioLabel mb-0'>{t("general.yes")}</p>
                                </div>
                                <div className='radio'>
                                    <input className="form-check-input" disabled={!isEditing} type="radio" name="is_food_allergic" id="0" checked={formData.is_food_allergic === "0"} onChange={handleInputChange} required />
                                    <p className='radioLabel mb-0'>{t("general.no")}</p>
                                </div>
                            </div>
                            {errors.is_food_allergic && <span className="error">{errors.is_food_allergic}</span>}
                            {formData?.is_food_allergic && formData?.is_food_allergic === "1" &&
                                <>
                                    <div className="form-item">
                                        <label for="food_allergic_details" className="form-label">{t("personal_info.Question4")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                        <textarea type="text" disabled={!isEditing} className="form-control" id="food_allergic_details" value={formData.food_allergic_details || ""} onChange={handleInputChange} required />
                                    </div>
                                    {errors.food_allergic_details && <span className="error">{errors.food_allergic_details}</span>}
                                </>
                            }
                            <div className="form-item">
                                <label>{t("personal_info.Question5")}
                                    <span style={{ "color": "#ff0000" }}>*</span></label>
                                <div className='radio'>
                                    <input className="form-check-input" disabled={!isEditing} type="radio" name="is_medicine_allergic" id="1" checked={formData.is_medicine_allergic === "1"} onChange={handleInputChange} />
                                    <p className='radioLabel mb-0'>{t("general.yes")}</p>
                                </div>
                                <div className='radio'>
                                    <input className="form-check-input" disabled={!isEditing} type="radio" name="is_medicine_allergic" id="0" checked={formData.is_medicine_allergic === "0"} onChange={handleInputChange} />
                                    <p className='radioLabel mb-0'>{t("general.no")}</p>
                                </div>
                            </div>
                            {errors.is_medicine_allergic && <span className="error">{errors.is_medicine_allergic}</span>}
                            {formData?.is_medicine_allergic && formData?.is_medicine_allergic === "1" &&
                                <>
                                    <div className="form-item">
                                        <label className="form-label">{t("personal_info.Question6")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                        <textarea type="text" disabled={!isEditing} className="form-control" id="medicine_allergic_details" value={formData.medicine_allergic_details || ""} onChange={handleInputChange} required />
                                    </div>
                                    {errors.medicine_allergic_details && <span className="error">{errors.medicine_allergic_details}</span>}
                                </>
                            }
                            {isEditing &&
                                <div className='submit-button d-flex justify-content-center mt-4 gap-3'>
                                    <Button buttonStyle='btn--primary' disabled={isSubmitting} onClick={toggleModal} type="button">
                                        {isSubmitting ? <AiOutlineLoading className="spin" /> : t("personal_info.save")}
                                    </Button>
                                </div>
                            }
                        </form>
                    </div>
                </>
            }

        </>
    )
}

export default ViewPersonalInfo